import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-timerange', 'TIME_START', 'Time start');
Labels.set('ui-timerange', 'TIME_END', 'Time end');
